import { useEffect, useState } from 'react';
import { base44 } from '@/api/base44Client';
import { AUSSTATTUNG_ALL } from '@/components/ui/ausstattungConfig';

// Fallback: the labels shipped with the app, used until the admin-managed
// records are loaded (or if there are none).
const FALLBACK = AUSSTATTUNG_ALL.map((item, index) => ({
  ...item,
  label_de: item.de,
  label_en: item.de,
  sort_order: (index + 1) * 10,
  is_active: true,
  id: `fallback-${item.value}`,
}));

let cache = null;
let pending = null;

const load = () => {
  if (cache) return Promise.resolve(cache);
  if (!pending) {
    pending = base44.entities.FacilityLabel
      .filter({ is_active: true }, 'sort_order')
      .then((records) => {
        const items = records && records.length ? records : FALLBACK;
        cache = items;
        return items;
      })
      .catch(() => FALLBACK)
      .finally(() => { pending = null; });
  }
  return pending;
};

/**
 * Facility labels for display and for the edit form.
 * Falls back to the built-in list while loading or if none are maintained.
 */
export default function useFacilityLabels() {
  const [items, setItems] = useState(cache || FALLBACK);

  useEffect(() => {
    let active = true;
    load().then((loaded) => { if (active) setItems(loaded); });
    return () => { active = false; };
  }, []);

  const getLabel = (value, language = 'de') => {
    const item = items.find((i) => i.value === value);
    if (!item) return value;
    if (language === 'en') return item.label_en || item.label_de || value;
    return item.label_de || item.de || value;
  };

  return { items, getLabel };
}